import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Layout from "./components/Layout";
import { LazyRoute } from "./components/PageLoader";
import HomePage from "./components/HomePage";

const AllProjects = lazy(() => import("./components/AllProjects"));
const AboutExtended = lazy(() => import("./components/AboutExtended"));
const ContactExtended = lazy(() => import("./components/ContactExtended"));
const Privacy = lazy(() => import("./components/Privacy"));
const Terms = lazy(() => import("./components/Terms"));
const ServicesExtended = lazy(() => import("./components/ServicesExtended"));
const CoreWebProjects = lazy(() => import("./components/CoreWebProjects"));
const LabExtended = lazy(() => import("./components/LabExtended"));
const BookCall = lazy(() => import("./components/BookCall"));
const SignContract = lazy(() => import("./components/SignContract"));
const ProjectGuide = lazy(() => import("./components/ProjectGuide"));
const AdminShell = lazy(() => import("./admin/AdminShell"));

const AdminFallback = () => (
  <div className="min-h-screen bg-[#0f1115]" aria-hidden="true" />
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <Layout>
              <HomePage />
            </Layout>
          }
        />
        <Route
          path="/projects"
          element={
            <Layout>
              <LazyRoute>
                <AllProjects />
              </LazyRoute>
            </Layout>
          }
        />
        <Route
          path="/about"
          element={
            <Layout>
              <LazyRoute>
                <AboutExtended />
              </LazyRoute>
            </Layout>
          }
        />
        <Route
          path="/services"
          element={
            <Layout>
              <LazyRoute>
                <ServicesExtended />
              </LazyRoute>
            </Layout>
          }
        />
        <Route
          path="/services/core-web-projects"
          element={
            <Layout>
              <LazyRoute>
                <CoreWebProjects />
              </LazyRoute>
            </Layout>
          }
        />
        <Route
          path="/lab"
          element={
            <Layout>
              <LazyRoute>
                <LabExtended />
              </LazyRoute>
            </Layout>
          }
        />
        <Route
          path="/contact"
          element={
            <Layout>
              <LazyRoute>
                <ContactExtended />
              </LazyRoute>
            </Layout>
          }
        />
        <Route
          path="/book"
          element={
            <Layout>
              <LazyRoute>
                <BookCall />
              </LazyRoute>
            </Layout>
          }
        />
        <Route
          path="/privacy"
          element={
            <Layout>
              <LazyRoute>
                <Privacy />
              </LazyRoute>
            </Layout>
          }
        />
        <Route
          path="/terms"
          element={
            <Layout>
              <LazyRoute>
                <Terms />
              </LazyRoute>
            </Layout>
          }
        />
        <Route
          path="/sign/:token"
          element={
            <LazyRoute>
              <SignContract />
            </LazyRoute>
          }
        />
        <Route
          path="/guide/:token"
          element={
            <LazyRoute>
              <ProjectGuide />
            </LazyRoute>
          }
        />
        <Route
          path="/guide/:token/print"
          element={
            <LazyRoute>
              <ProjectGuide />
            </LazyRoute>
          }
        />
        <Route
          path="/admin/*"
          element={
            <Suspense fallback={<AdminFallback />}>
              <AdminShell />
            </Suspense>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
